import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Returns Tailwind color classes based on accuracy percentage.
 * - Green: ≥ 90%
 * - Yellow: 75% to 89%
 * - Red: < 75%
 */
export function getAccuracyColorClass(accuracy: number): string {
	if (accuracy >= 90) return "text-green-600 dark:text-green-400";
	if (accuracy >= 75) return "text-yellow-600 dark:text-yellow-400";
	return "text-red-600 dark:text-red-400";
}
